/**
 * Extrahuje zákresy etap pro ZBO
 */
export const getZboZakresyEtap = (activeInfo) => {
    var _a, _b;
    if (!(activeInfo === null || activeInfo === void 0 ? void 0 : activeInfo.pripad)) {
        return [];
    }
    return ((_b = (_a = activeInfo.pripad.zabor) === null || _a === void 0 ? void 0 : _a.etapy) !== null && _b !== void 0 ? _b : []).map((etapa) => { var _a; return (_a = etapa.zakres) !== null && _a !== void 0 ? _a : null; });
};
/**
 * Extrahuje zákresy etap pro AG
 */
export const getAgZakresyEtap = (activeInfo) => {
    var _a, _b;
    if (!(activeInfo === null || activeInfo === void 0 ? void 0 : activeInfo.pripad)) {
        return [];
    }
    return ((_b = (_a = activeInfo.pripad.zabor) === null || _a === void 0 ? void 0 : _a.etapy) !== null && _b !== void 0 ? _b : []).map((etapa) => { var _a; return (_a = etapa.zakresExt) !== null && _a !== void 0 ? _a : null; });
};
/**
 * Parsuje GeoJSON z řetězce a filtruje validní zákresy
 */
export const parseFeaturesFromZakresy = (zakresy) => {
    return zakresy
        .map(zakres => (zakres ? JSON.parse(zakres) : null))
        .filter(Boolean)
        .flat();
};
/**
 * Vytvoří ukazatele na features načtené do dané vrstvy mapia.
 * Slouží pro zoom nad všemi zákresy dohromady (záložka "Vše").
 */
export const createFeaturePointers = (features, layerId) => {
    return features
        .map(feature => { var _a, _b; return ({ layerId, featureId: (_b = (_a = feature === null || feature === void 0 ? void 0 : feature.properties) === null || _a === void 0 ? void 0 : _a.featureId) !== null && _b !== void 0 ? _b : feature === null || feature === void 0 ? void 0 : feature.id }); })
        .filter(pointer => pointer.featureId != null);
};
/**
 * Zjistí, zda má aktivní případ etapy
 */
export const hasEtapy = (activeInfo) => {
    var _a, _b, _c, _d;
    return ((_d = (_c = (_b = (_a = activeInfo === null || activeInfo === void 0 ? void 0 : activeInfo.pripad) === null || _a === void 0 ? void 0 : _a.zabor) === null || _b === void 0 ? void 0 : _b.etapy) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0;
};
/**
 * Vrátí počet etap
 */
export const getEtapyCount = (activeInfo) => {
    var _a, _b, _c, _d;
    return (_d = (_c = (_b = (_a = activeInfo === null || activeInfo === void 0 ? void 0 : activeInfo.pripad) === null || _a === void 0 ? void 0 : _a.zabor) === null || _b === void 0 ? void 0 : _b.etapy) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
};
/**
 * Vrátí konkrétní etapu
 */
export const getEtapa = (activeInfo, index) => {
    var _a, _b, _c;
    return (_c = (_b = (_a = activeInfo === null || activeInfo === void 0 ? void 0 : activeInfo.pripad) === null || _a === void 0 ? void 0 : _a.zabor) === null || _b === void 0 ? void 0 : _b.etapy) === null || _c === void 0 ? void 0 : _c[index];
};
//# sourceMappingURL=mapioHelpers.js.map